export default {
  MENU: 'MENU',
  STEP_BAR: 'STEP_BAR',
  LANGUAGE: 'LANGUAGE',
  LOGIN: 'LOGIN'
}
